import { type FC } from 'react'
import { Dropdown } from 'react-bootstrap'
import classNames from 'classnames'
import { type TemplateValue } from '../../../models/TemplateLibrary'
import { currentFirst } from '../../Setup/Scheduling/sections/EmailTemplatesSetup/currentFirst'
import { NeedsFixingBadge } from '../../Setup/Scheduling/sections/EmailTemplatesSetup/TemplatePicker'
import { TemplateScopeBadge } from '../../Setup/Templates/TemplateScopeBadge'
import { needsFixing } from './followUpTemplates'
import styles from './FollowUpTemplateSelect.module.scss'

interface FollowUpTemplateSelectProps {
  templates: TemplateValue[]
  selected: TemplateValue
  disabled: boolean
  onSelect: (templateId: string) => void
}

const TemplateName: FC<{ template: TemplateValue }> = ({ template }) => (
  <span className='d-flex align-items-center gap-2 mw-0 paragraph-medium zocks-text-gray-900'>
    <span className='text-truncate'>{template.name}</span>
    <span className='flex-shrink-0 text-nowrap paragraph-small'>
      <TemplateScopeBadge scope={template.scope} />
    </span>
  </span>
)

export const FollowUpTemplateSelect: FC<FollowUpTemplateSelectProps> = ({ templates, selected, disabled, onSelect }) => (
  <Dropdown>
    <Dropdown.Toggle
      as='button'
      type='button'
      disabled={disabled}
      aria-label='Template'
      className={classNames(
        styles.toggle,
        'd-flex align-items-center justify-content-between gap-2 w-100 border rounded-2 px-3 py-2 text-start zocks-border-color-gray-300 zocks-bg-color-white',
      )}
    >
      <TemplateName template={selected} />
      <i className='bi bi-chevron-expand zocks-text-gray-600' aria-hidden='true' />
    </Dropdown.Toggle>
    <Dropdown.Menu className='w-100 py-0'>
      {currentFirst(templates, selected.id).map((template) => {
        const isBroken = needsFixing(template)
        return (
          <Dropdown.Item
            key={template.id}
            as='button'
            type='button'
            disabled={isBroken}
            active={template.id === selected.id}
            className={classNames('d-flex flex-column zocks-gap-0.125 py-2', { 'opacity-50': isBroken })}
            onClick={() => onSelect(template.id)}
          >
            <span className='d-flex align-items-center justify-content-between w-100'>
              <span className='d-flex align-items-center gap-2'>
                <TemplateName template={template} />
                {isBroken ? <NeedsFixingBadge /> : null}
              </span>
              {template.id === selected.id ? <i className='bi bi-check zocks-text-primary' aria-hidden='true' /> : null}
            </span>
            <span className='paragraph-small zocks-text-gray-600 text-wrap'>
              {isBroken ? "Can't be sent until it's fixed in the template library." : template.description}
            </span>
          </Dropdown.Item>
        )
      })}
    </Dropdown.Menu>
  </Dropdown>
)
